<template>
	<aside class="console-sider">
		<div class="console-sider__scroll">
			<section class="console-sider__group" v-for="group in sidebarGroups" :key="group.title">
				<div class="console-sider__group-title">
					<span>{{ group.title }}</span>
				</div>
				<div class="console-sider__items">
					<button
						v-for="item in group.items"
						:key="item.title + (item.hash || '')"
						:class="{ active: isActive(item) }"
						@click="navigate(item)"
					>
						<i :class="item.icon || group.icon || 'fa fa-circle-o'"></i>
						<span>{{ item.title }}</span>
					</button>
				</div>
			</section>
		</div>
		<div class="console-sider__collapse">
			<button class="console-sider__collapse-btn" @click="toggleCollapse">
				<i :class="sliderCollapsed ? 'fa fa-angle-right' : 'fa fa-angle-left'"></i>
				<span v-if="!sliderCollapsed">收起侧边栏</span>
			</button>
		</div>
	</aside>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { getSidebarGroups } from '../../js/config/site-nav';

export default {
	name: 'AppMenu',
	computed: {
		...mapState(['User', 'sliderCollapsed']),
		...mapGetters(['isAuthenticated']),
		sidebarGroups() {
			return getSidebarGroups(this.$route.meta.section, {
				isAuthenticated: this.isAuthenticated,
				role: this.User && this.User.role
			});
		}
	},
	methods: {
		isActive(item) {
			if (item.routeName && this.$route.name !== item.routeName) {
				return false;
			}
			if (item.hash) {
				return this.$route.hash === item.hash;
			}
			if (item.query && item.query.category) {
				return this.$route.query.category === item.query.category;
			}
			return this.$route.name === item.routeName;
		},
		navigate(item) {
			if (item.external) {
				window.open(item.external, '_blank');
				return;
			}
			this.$router.push({
				name: item.routeName,
				hash: item.hash || undefined,
				query: item.query || undefined
			});
		},
		toggleCollapse() {
			this.$store.commit('updateSliderCollapse', !this.sliderCollapsed);
		}
	}
};
</script>
